import { createFileRoute, useLocation } from '@tanstack/react-router'
import { z } from 'zod'
import { RentalCreateForm, rentalListSearchSchema } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/rentals/batch-new')({
  loaderDeps: ({ search }) => ({ customerId: search.customerId }),
  loader: async ({ context, deps }) => {
    if (!deps.customerId) {
      return undefined
    }
    const customers = await context.queryClient.fetchQuery(
      context.trpc.lookup.customers.queryOptions({ purpose: 'order.rental.read', selectedId: deps.customerId })
    )
    return customers.at(0)
  },
  validateSearch: z.object({
    customerId: z.coerce.number().int().positive().optional().catch(undefined)
  }),
  component: NewRentalPage
})
function NewRentalPage() {
  const { currentSession } = Route.useRouteContext()
  const can = (permission: (typeof currentSession.permissions)[number]) =>
    currentSession.isSuperAdmin || currentSession.permissions.includes(permission)
  const { customerId } = Route.useSearch()
  const savedReturnSearch = useLocation({ select: (location) => location.state.rentalListReturnSearch })
  const returnSearch = rentalListSearchSchema.parse(savedReturnSearch ?? {})
  return (
    <RentalCreateForm
      batch
      key={customerId}
      initialCustomer={Route.useLoaderData()}
      returnSearch={returnSearch}
      canCreateBusiness={currentSession.isSuperAdmin || currentSession.permissions.includes('business.create')}
      canCreateCustomer={can('customer.create')}
      quickMemberTypes={[
        ...(can('member.employee.create') ? ['employee' as const] : []),
        ...(can('member.agent.create') ? ['agent' as const] : [])
      ]}
    />
  )
}
